import { AccountLayout } from "./components/layout/AccountLayout"
import { AuthOverlay } from "./components/AuthOverlay"
import { appRoutes } from "./constants/routes"
import { useAppDispatch, useAppSelector } from "./store"
import { getAllItems } from "./store/thunks/marketThunks"
import NotFoundPage from "./pages/NotFoundPage"
import React, { useEffect } from "react"
import { Route, Routes } from "react-router-dom"

const AppRouter = () => {
  const dispatch = useAppDispatch()
  const isAuth = useAppSelector((state) => state.user.isAuth)

  useEffect(() => {
    if (isAuth) {
      dispatch(getAllItems(1, { rarity: 0, lvl: 0, price: 0 }))
      // dispatch(getInventarCards())
      // getWalletBalance().then((balance) => {
      //   dispatch(setWalletBalance(balance))
      // })
    }
  }, [isAuth])

  return (
    <Routes>
      {appRoutes.map(({ path, Element, isActive, type }, index) => (
        <React.Fragment key={index}>
          {type === "public" && (
            <Route
              key={path}
              path={path}
              element={
                // <div className={`page ${path.replace("/", "")}-page ${!isActive ? "unavailable-page" : ""}`}>
                <div className={path === '/' ? '' : `page ${path.replace("/", "")}-page`}>
                  <Element />
                </div>
              }
            />
          )}
        </React.Fragment>
      ))}

      {/* Приватные маршруты - всегда доступны, но с оверлеем для неавторизованных */}
      <Route element={<AccountLayout />}>
        {appRoutes.map(({ path, Element, isActive, type }, index) => (
          <React.Fragment key={index}>
            {type === "private" && (
              <Route
                key={path}
                path={path}
                element={
                  // <div className={`page ${path.replace("/", "")}-page ${!isActive ? "unavailable-page" : ""}`}>
                  <div className={`page ${path.replace("/", "")}-page`}>
                    {isAuth ? (
                      <Element />
                    ) : (
                      <AuthOverlay>
                        <Element />
                      </AuthOverlay>
                    )}
                  </div>
                }
              />
            )}
          </React.Fragment>
        ))}
      </Route>

      {/* Обработка 404 страницы - должна быть в конце */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  )
}

export default AppRouter
